import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { mapState, mapActions } from 'vuex';
import dayjs from 'dayjs';
export default {
  computed: _objectSpread({}, mapState('d2admin/user', ['info'])),
  data: function data() {
    return {
      labelWidth: '100px',
      currentUser: localStorage.getItem('userId'),
      changePwdDialogShow: false,
      changeUserInfoDialogShow: false,
      userInfoData: {
        account: null,
        nickname: null,
        gender: null,
        headImage: null,
        remark: null
      },
      emptyUserInfoData: {},
      pwdData: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
      },
      emptyPwdData: {},
      pwdRules: {
        oldPassword: [{
          required: true,
          message: '旧密码不能为空',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '新密码不能为空',
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          message: '确认密码不能为空',
          trigger: 'blur'
        }, {
          validator: this.confirmPwd,
          trigger: 'blur'
        }]
      },
      userInfoRules: {
        nickname: [{
          required: true,
          message: '用户昵称不能为空',
          trigger: 'blur'
        }]
      },
      wxBindState: false //微信网站OpenId绑定状态
    };
  },
  mounted: function mounted() {
    this.emptyPwdData = JSON.parse(JSON.stringify(this.pwdData));
    this.emptyUserInfoData = JSON.parse(JSON.stringify(this.userInfoData));
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), {}, {
    currentUserEditor: function currentUserEditor() {
      var _this = this;
      this.$api.userDetail(localStorage.getItem('userId')).then(function (res) {
        _this.userInfoData = res.data;
        _this.changeUserInfoDialogShow = true;
      });
    },
    closeUserInfoDialogShow: function closeUserInfoDialogShow() {
      this.changeUserInfoDialogShow = false;
      this.userInfoData = this.emptyUserInfoData;
    },
    changePassword: function changePassword() {
      this.changePwdDialogShow = true;
    },
    closePwdDialogShow: function closePwdDialogShow() {
      this.changePwdDialogShow = false;
      this.pwdData = this.emptyPwdData;
    } // 图片上传
    ,
    beforeFileUpload: function beforeFileUpload(file) {
      // 检查图片类型
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }

      // 检查图片大小
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              // 获取阿里OSS签名
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.userInfoData.headImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeFile: function removeFile() {
      this.userInfoData.headImage = '';
    },
    submitPwdData: function submitPwdData() {
      var _this3 = this;
      this.$refs['pwdDataVerify'].validate(function (valid) {
        if (valid) {
          // 表单提交，调用 “修改接口”，将修改后数据保存到后端
          _this3.$api.userChangeCurrentPassword(_this3.pwdData).then(function (res) {
            if (res.data) {
              _this3.$message.success('修改成功');
              _this3.pwdData = _this3.emptyPwdData;
              _this3.changePwdDialogShow = false;
              _this3.logout({
                confirm: false
              });
            } else {
              _this3.$message.error('修改失败');
            }
          });
        }
      });
    },
    submitUserInfoData: function submitUserInfoData() {
      var _this4 = this;
      this.$refs['userInfoDataVerify'].validate(function (valid) {
        if (valid) {
          _this4.$api.userModify(_this4.userInfoData).then(function (res) {
            if (res.data) {
              _this4.$message.success('修改成功');
              _this4.userInfoData = _this4.emptyUserInfoData;
              _this4.changeUserInfoDialogShow = false;
            } else {
              _this4.$message.error('修改失败');
            }
          });
        }
      });
    },
    confirmPwd: function confirmPwd(rule, value, callback) {
      if (value !== this.pwdData.newPassword) {
        callback(new Error('确认密码与新密码不一致!'));
      } else {
        callback();
      }
    },
    logOff: function logOff() {
      this.$api.userSignRevoke().then(function (res) {});
      this.logout({
        confirm: true
      });
    }
  })
};